var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsDownOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28073 12.4V15.6C7.28073 16.2365 7.53912 16.847 7.99906 17.2971C8.45901 17.7471 9.08282 18 9.73328 18L13.0034 10.8V2.0001H3.78175C3.38743 1.99574 3.0048 2.13098 2.70433 2.38089C2.40387 2.63081 2.20583 2.97857 2.14671 3.36009L1.01853 10.56C0.982966 10.7894 0.998771 11.0235 1.06485 11.2462C1.13094 11.469 1.24572 11.675 1.40125 11.85C1.55678 12.0251 1.74933 12.1649 1.96557 12.2599C2.18181 12.3548 2.41657 12.4027 2.65357 12.4H7.28073Z",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 10.0009,
    width: 4.00111,
    height: 8,
    rx: 0.4,
    transform: "rotate(180 19 10.0009)",
    stroke: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDownOutlined);
export default __webpack_public_path__ + "static/media/thumbs_down_outlined.84bbdc45.svg";
export { ForwardRef as ReactComponent };